export class Accordion
{
    constructor()
    {

        this.tabs = document.querySelectorAll('*[dropdown]')
        this.tabs.forEach(t => {

            let trigger = t.querySelector('.dropdown--trigger')

            let height = t.scrollHeight
            let triggerHeight = trigger.scrollHeight

            t.style.setProperty('--max-height', height + 'px')
            t.style.setProperty('--init-height', triggerHeight + 'px')

            trigger.addEventListener('click', e => {
                e.preventDefault()
                t.classList.toggle('open')
            })
        })
    }
}
